import {
  FormControl as MaterialFormControl,
  RadioGroup as MaterialRadioGroup,
  FormControlLabel as MaterialFormControlLabel,
} from '@material-ui/core';
import { darken } from 'polished';
import styled, { css } from 'styled-components';

import Button from '../../components/Button';
import colors from '../../styles/colors';

export const Container = styled.div`
  .MuiBox-root {
    padding: 1.07rem;
  }
`;

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.07rem;

  a {
    background: ${colors.primary};
    color: ${colors.white};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 12.8rem;
    text-transform: uppercase;
    padding: 0.8rem 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.2em;
    border-radius: 5px;
    transition: ease-in background 0.2s;

    &:hover {
      background: ${darken(0.03, `${colors.primary}`)};
    }
  }

  button {
    background: none;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
    text-transform: uppercase;
    padding: 0.8rem 0;
    transition: ease-in background 0.2s;
    width: 12.8rem;
    margin-right: 1.4rem;
    border-radius: 5px;
    font-weight: 500;

    &:hover {
      color: ${colors.white};
      background: ${colors.primary};
      border: 0;
    }
  }
`;

export const TaskTitle = styled.h1`
  color: #1a1a1a;
  font-weight: bold;
  font-size: 24px;
  margin: 1.1rem 0;
`;
export const ContainerInputSearch = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  border: 1px solid ${colors.gray};
  background: ${colors.white};
  border-radius: 5px;
  padding: 0.7rem;

  svg {
    margin-right: 0.3rem;
    fill: ${colors.gray};
  }

  input {
    width: 100%;
    background: none;
    border: 0;

    &::placeholder {
      color: ${colors.gray};
    }
  }
`;

export const NoRequestAvailable = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 40rem;
  margin: 0 auto;

  text-align: center;

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 1.1rem;
    width: 6.8rem;
    height: 6.8rem;
    border-radius: 50%;
  }

  p {
    font-size: 24px;
    margin: 1.7rem 0 0.5rem 0;
    color: #6c6c6c;
  }

  span {
    font-size: 16px;
    color: #6c6c6c;
  }
`;

export const ContentMaterial = styled.div`
  background: ${colors.white};

  .MuiTab-root {
    text-transform: none;
    min-width: 7.8rem !important;
  }

  .MuiTabs-flexContainer {
    border-bottom: 1px solid #e6e6e6;
  }

  .MuiTab-textColorInherit {
    color: #b3b3b3;
    font-size: 16px;
    font-weight: bold;
  }

  .MuiTab-textColorInherit.Mui-selected {
    color: #1a1a1a;
    font-weight: bold;
  }

  .MuiTabs-indicator {
    border: 2px solid #e00042;
    border-radius: 5px;
    width: 6.5rem !important;
    margin-left: 0.7rem;
  }
`;

interface RowDataProps {
  status: string;
}

export const RowData = styled.tr<RowDataProps>`
  svg {
    cursor: pointer;
    transition: ease-in all 0.2s;
    &:hover {
      color: ${colors.primary};
    }
  }

  td {
    &:first-child {
      width: 2.8rem;
      padding: 0 !important;
      text-align: left;

      &:before {
        content: '';
        border-radius: 5px;
        padding-top: 0.7rem !important;
        padding-bottom: 0.7rem !important;

        ${(props) =>
          props.status === 'Atrasada' &&
          css`
            border-left: 5px solid #c11e1e;
          `}

        ${(props) =>
          props.status === 'Próximo a vencer' &&
          css`
            border-left: 5px solid #ff8000;
          `}
      }
    }
    &:last-child {
      text-align: center;
    }
    height: 4.2rem;
    font-size: 14px;
    color: ${colors.lightblack};
    text-align: left;

    span {
      display: block;
      font-size: 14px;

      ${(props) =>
        props.status === 'Atrasada' &&
        css`
          color: #c11e1e;
        `}

      ${(props) =>
        props.status === 'Próximo a vencer' &&
        css`
          color: #ff8000;
        `}

      ${(props) =>
        props.status === 'No prazo' &&
        css`
          color: #808080;
        `}
    }
  }
`;

export const ModalResponsaveis = styled.div`
  font-size: 24px;
  color: #4d4d4d;
`;

export const CustomButton = styled(Button)`
  padding: 0 0.7rem;
`;

export const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FormControl = styled(MaterialFormControl)`
  margin-bottom: 2.4rem !important;
`;

export const RadioGroup = styled(MaterialRadioGroup)``;

export const FormControlLabel = styled(MaterialFormControlLabel)`
  height: 1.5rem;
  border-radius: 11px;
  margin-left: 0px !important;
  padding: 0.2rem 1.1rem;
  font-size: 12px;
  transition: color 0.5s;
  transition: background-color 0.5s;
  transition: ease-in 0.2s;

  ${(props) =>
    props.checked &&
    css`
      color: #eb0045;
      background-color: #ff99b8;
    `}

  ${(props) =>
    !props.checked &&
    css`
      color: #4d4d4d;
      background-color: transparent;
      border: 1px solid #eb0045;
    `}


  & span:first-child {
    display: none;
  }
`;

export const Sortable = styled.button`
  display: flex;
  border: 0;
  font-size: 14px;
  font-family: 'Exo 2', sans-serif;
  font-weight: bolder;
  background: none;
  align-self: flex-end;
  color: #6c6c6c;

  svg {
    margin-left: 0.3rem;
  }
`;

export const ModalTitle = styled.h1`
  font-size: 24px;
  color: #4d4d4d;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: rgba(0, 0, 0, 0.1);
    margin: 1.1rem 0 1.8rem 0;
  }
`;

export const CloseButtonModal = styled.button`
  border: 0;
  background: none;
  align-self: flex-end;
  margin-left: 3.5rem;

  svg {
    fill: ${colors.gray};
  }
`;
